import { MarketType } from '../model/market-type';
export const generateOrderDetailsLink = (accountId, orderId, marketType, isTM1) => `${isTM1 ? '/v1' : ''}/${accountId || 0}/${encodeURIComponent(orderId || '')}?marketType=${marketType || MarketType.PRIMARY}`;
